<script setup>
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import Button from 'dashboard/components-next/button/Button.vue';

// Endereço /inboxes/new/<canal> que não bate com nenhum canal (link antigo ou
// digitado errado): em vez de tela vazia, diz o que houve e leva à lista.
const { t } = useI18n();
const router = useRouter();

const goToChannelList = () => router.push({ name: 'settings_inbox_new' });
</script>

<template>
  <div
    class="flex flex-col items-center justify-center w-full h-full gap-3 p-6 text-center"
    role="alert"
  >
    <span class="i-ph-plugs size-10 text-n-slate-10" aria-hidden="true" />
    <h2 class="text-heading-2 text-n-slate-12">
      {{ t('INBOX_MGMT.ADD.CHANNEL_NOT_FOUND.TITLE') }}
    </h2>
    <p class="max-w-md mb-0 text-body-main text-n-slate-11">
      {{ t('INBOX_MGMT.ADD.CHANNEL_NOT_FOUND.DESCRIPTION') }}
    </p>
    <Button
      :label="t('INBOX_MGMT.ADD.CHANNEL_NOT_FOUND.BACK')"
      icon="i-ph-arrow-left"
      size="sm"
      @click="goToChannelList"
    />
  </div>
</template>
